import React from 'react'
import { useAbout, AboutProps } from './useAbout'
import styles from './About.module.scss'
import TitleSection from 'components/TitleSection/TitleSection'
import AboutValueItem from 'components/AboutValueItem/AboutValueItem'
import aboutImg from 'img/Landing/about.webp'

const About: React.FC<AboutProps> = (props: AboutProps) => {
  const {} = useAbout(props)

  return (
    <section id='about' className={styles.about}>
      <TitleSection
        title='About'
        descriptionTitle='About'
        description='Empowering restaurants through smart digital menus'
      />

      <div className='container'>
        <div className='row align-items-center gy-5'>
          <div className='col-lg-6'>
            <div
              className={`${styles['about-image-wrapper']} position-relative`}
            >
              <img
                src={aboutImg}
                alt='About Us'
                className='img-fluid rounded-4'
              />
              <div className={styles['mission-card']}>
                <div className={styles['mission-icon']}>
                  <i className='bi bi-lightbulb'></i>
                </div>
                <div className={styles['mission-content']}>
                  <h4>Our Mission</h4>
                  <p>
                    Make digital menus easy, beautiful, and accessible for every
                    restaurant.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className='col-lg-6'>
            <div className={`${styles['about-content']} ps-lg-4`}>
              <div className={styles['tag-badge']}>OUR STORY</div>
              <h2 className='mb-4'>
                Redefining menus for a mobile-first dining experience
              </h2>
              <div className={styles['about-info']}>
                <p>
                  At ByteBuffetBox, we set out to eliminate the pain of outdated
                  PDFs and clunky paper menus. Our goal is simple: give
                  restaurants a powerful, mobile-first menu that looks great,
                  updates instantly, and delights customers.
                </p>
                <p>
                  We’re a passionate team of designers, developers, and food
                  lovers working to bring innovation to every table. By focusing
                  on speed, simplicity, and style, we’re helping hospitality
                  businesses stand out and stay ahead.
                </p>
              </div>
              <h4 className={`${styles['values-title']} mt-4 mb-3`}>
                Fundamental Principles
              </h4>
              <div className={styles['values-list']}>
                <AboutValueItem label='Ease of Use' />
                <AboutValueItem label='Mobile First' />
                <AboutValueItem label='Beautiful Design' />
                <AboutValueItem label='Instant Updates' />
                <AboutValueItem label='Scalable Tech' />
                <AboutValueItem label='Lightning Fast' />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default About
